// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_UJQ","cls2":"PaperPreviewList-cls2_B1C PaperPreviewList-cls1_UJQ","spin":"PaperPreviewList-spin__dk"};